var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true },
        },
      ],
      staticClass: "app-container",
      attrs: { "element-loading-text": "加载中..." },
    },
    [
      _c(
        "el-card",
        {
          staticClass: "sticky-container",
          attrs: { shadow: "never", "body-style": { padding: 0 } },
        },
        [
          _c(
            "template",
            { slot: "header" },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleFilter },
                  model: {
                    value: _vm.queryParams.isOnsale,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryParams, "isOnsale", $$v)
                    },
                    expression: "queryParams.isOnsale",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "出售中的商品", name: "1" },
                  }),
                  _c("el-tab-pane", {
                    attrs: { label: "仓库中的商品", name: "0" },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                { staticClass: "filter-container", attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 6 } },
                    [
                      _c("el-input", {
                        staticClass: "filter-item",
                        attrs: { placeholder: "商品名称" },
                        model: {
                          value: _vm.queryParams.goodsName,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryParams, "goodsName", $$v)
                          },
                          expression: "queryParams.goodsName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 3 } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "激活专区", clearable: "" },
                          model: {
                            value: _vm.queryParams.section,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "section", $$v)
                            },
                            expression: "queryParams.section",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "所有专区", value: "0" },
                          }),
                          _c("el-option", {
                            attrs: { label: "专区一", value: "1" },
                          }),
                          _c("el-option", {
                            attrs: { label: "专区二", value: "2" },
                          }),
                          _c("el-option", {
                            attrs: { label: "专区三", value: "3" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 9 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v("查找")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "danger", icon: "el-icon-edit" },
                          on: { click: _vm.handleCreate },
                        },
                        [_vm._v("上架商品")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("data-table", {
            attrs: {
              "page-index": _vm.queryParams.page,
              limit: _vm.queryParams.limit,
              mall: "premium",
              list: _vm.list,
            },
            on: { edit: _vm.handleEdit, delete: _vm.handleRemove },
          }),
          _c("pagination", {
            attrs: {
              total: _vm.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }